<cs-label class="site-name">{{ siteName }}</cs-label>
<div class="content-wrapper">
  <div class="site-photo-container">
    <img class="site-photo" [src]="sitePhoto" [alt]="siteName" />
  </div>
  <div class="measurements-container">
    @for (i of measurementIndices; track i) {
      <cs-input-measure type="skinfold_mm" [canonValue]="measures[i]"
        (canonValueChange)="updateMeasure(i, $event)" [readonly]="readonly"
        [suggestedPreselectValue]="getPreselectValue()" input-sequence>
      </cs-input-measure>
    }
  </div>
</div>